import {
  CLASS_SUBTOPIC_OVERALL_REPORT_REQUESTED,
  CLASS_SUBTOPIC_SKILL_REPORT_REQUESTED,
  FETCH_CT_QUESTION,
  FETCH_CT_QUESTION_RESET,
  SCHOOL_SUBTOPIC_OVERALL_REPORT_REQUESTED,
  SCHOOL_SUBTOPIC_SKILL_REPORT_REQUESTED,
  SELECT_CLASS,
  SELECT_COMPETITION,
  SELECT_SCHOOL,
  SELECT_STUDENT,
  SET_IS_VIEWING_STATUS,
  SUBTOPIC_REPORT_RESET,
  CHANGE_LANGUAGE,
  COMPETITION_RESET_REQUESTED,
  RESET_COMPETITION_RESCHEDULE,
  DOWNLOAD_REPORT_REQUESTED,
} from "./actionTypes";

export const downloadReport = (competitionId, schoolId) => {
  return {
    type: DOWNLOAD_REPORT_REQUESTED,
    competitionId, 
    schoolId,
  }
}

export const resetCompetition = (competitionId, classCode, studentId, start_time, end_time) => {
  return {
    type: COMPETITION_RESET_REQUESTED,
    competitionId, 
    classCode, 
    studentId, 
    start_time, 
    end_time
  }
}

export const resetCompetitionReschedule = () => {
  return {
    type: RESET_COMPETITION_RESCHEDULE,
  }
}

export const selectCompetition = (competition) => {
  return {
    type: SELECT_COMPETITION,
    competition,
  };
};

export const selectSchool = (school) => {
  return {
    type: SELECT_SCHOOL,
    school,
  };
};

export const selectClass = (schoolClass) => {
  return {
    type: SELECT_CLASS,
    schoolClass,
  };
};

export const selectStudent = (selectStudent) => {
  return {
    type: SELECT_STUDENT,
    selectStudent,
  };
};

export const setIsViewingStatus = (isViewingStatus) => {
  return {
    type: SET_IS_VIEWING_STATUS,
    isViewingStatus,
  };
};

export const fetchSchoolSubtopicOverallReport = payload => {
  return {
    type: SCHOOL_SUBTOPIC_OVERALL_REPORT_REQUESTED,
    payload
  };
};

export const fetchClassSubtopicOverallReport = payload => {
  return {
    type: CLASS_SUBTOPIC_OVERALL_REPORT_REQUESTED,
    payload
  };
};

export const fetchSchoolSubtopicSkillReport = payload => {
  return {
    type: SCHOOL_SUBTOPIC_SKILL_REPORT_REQUESTED,
    payload
  };
};

export const fetchClassSubtopicSkillReport = payload => {
  return {
    type: CLASS_SUBTOPIC_SKILL_REPORT_REQUESTED,
    payload
  };
};

export const fetchQuestion = payload => {
  return {
    type: FETCH_CT_QUESTION,
    payload
  };
};

export const subtopicReportReset = () => {
  return {
    type: SUBTOPIC_REPORT_RESET
  };
};

export const fetchQuestionReset = () => {
  return {
    type: FETCH_CT_QUESTION_RESET
  };
};

export const changeLanguage = (lang) =>{
  return{
    type: CHANGE_LANGUAGE,
    lang
  }
}
